import React from 'react';
import { DefaultShipping } from '../partials/shipping/DefaultShipping';
import { EmptyShippingMessage } from '../partials/shipping/EmptyShippingMessage';
import { GCC_COUNTER_TOPS } from '../../components/constants';
import {
  getShippingThreshold,
  getSellableQuantityYourStore,
  isAppliance,
  isBackorderedWithDate,
  isBackordered,
  isBODFS,
  isDiscontinued,
  hasFreeShipping,
  isLiveGoods,
  isNextDayDelivery,
  isOutOfStockOnline,
  isSameDayDelivery,
  isSTH,
  shouldShowShippingThreshold,
  meetsApplianceDeliveryThreshold,
  applianceDeliveryThreshold
} from './pod-fulfillment-utils';
import { dataModel } from '../../components/dataModel';

export const getShippingTemplate = ({ product }) => {

  const isGCCCounter = product?.info?.globalCustomConfigurator?.customExperience === GCC_COUNTER_TOPS;

  if (!product || isGCCCounter) return EmptyShippingMessage;

  /* -----LiveGoods----- */
  if (isLiveGoods(product)) {
    if (!getSellableQuantityYourStore(product)) {
      return EmptyShippingMessage;
    }
  }

  if (isDiscontinued(product)) {
    return () => (
      <DefaultShipping
        shippingMessage="No longer available"
      />
    );
  }

  /* -----Appliance----- */
  if (isAppliance(product)) {
    if (meetsApplianceDeliveryThreshold(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage="Free"
        />
      );
    }
    return () => (
      <DefaultShipping
        alertType="success"
        shippingMessageStyle="shipping__success"
        shippingMessage={`Free on appliance orders $${applianceDeliveryThreshold()}+`}
      />
    );
  }

  /* -----STH Only----- */
  if (isSTH(product) && !isBODFS(product)) {
    if (isBackorderedWithDate(product) || isBackordered(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage="Standard"
        />
      );
    }
    if (hasFreeShipping(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage="Free"
        />
      );
    }
    if (getShippingThreshold(product)) {
      let shippingMessage = shouldShowShippingThreshold(product, getShippingThreshold(product))
        ? `Free with $${getShippingThreshold(product)} order`
        : 'Free';
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage={shippingMessage}
        />
      );
    }
    return () => (
      <DefaultShipping
        alertType="success"
        shippingMessage="Standard"
      />
    );
  }

  /* -----BODFS only----- */
  if (isBODFS(product) && !isSTH(product)) {
    // TODO: temporarily bypass same/next-day messaging for covid response
    /*
    if (isSameDayDelivery(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage="Same-day"
        />
      );
    }
    if (isNextDayDelivery(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage="Next-day"
        />
      );
    }
    */
    return () => (
      <DefaultShipping
        alertType="success"
        shippingMessage="Scheduled"
      />
    );
  }

  /* -----STH and BODFS----- */
  if (isBODFS(product) && isSTH(product)) {
    if (hasFreeShipping(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage="Free"
        />
      );
    }
    if (getShippingThreshold(product)) {
      let shippingMessage = shouldShowShippingThreshold(product, getShippingThreshold(product))
        ? `Free with $${getShippingThreshold(product)} order`
        : 'Free';
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage={shippingMessage}
        />
      );
    }
    return () => (
      <DefaultShipping
        alertType="success"
        shippingMessage="Standard"
      />
    );
  }

  /* -----not STH and not BODFS means no delivery to customer directly----- */
  if (!isBODFS() && !isSTH()) {
    if (isDiscontinued(product)) {
      return EmptyShippingMessage;
    }
    if (isOutOfStockOnline(product)) {
      return () => (
        <DefaultShipping
          shippingMessage="Unavailable"
        />
      );
    }
    return () => (
      <DefaultShipping
        shippingMessage="Unavailable"
      />
    );
  }

  return () => EmptyShippingMessage;
};

getShippingTemplate.dataModel = dataModel;
